//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BlogCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    getTitle () {
      return this.item.data.title || this.item.name
    },
    getShort () {
      return this.item.data.content
    },
    getPublishingDate () {
      return this.item.publishing_date
    },
    getReadingDate () {
      return this.item.reading_time
    },
    getLink () {
      return {
        name: 'blogs-article',
        params: { category: this.item.categories[0]?.data?.slug, blogSlug: this.item.data.slug }
      }
    },
    getImage () {
      return this.item.image
    },
    getCategories () {
      return this.item.categories
    }
  }
}
